





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR
// GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR


const GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR= createAsyncThunk(
  "getAllRejectedCustomersWithCreatorAndRejector/getAllRejectedCustomersWithCreatorAndRejector",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllRejectedCustomersWithCreatorAndRejectorSlice = createSlice({
  name: "getAllRejectedCustomersWithCreatorAndRejectorSlice",
  initialState: {
    getAllRejectedCustomersWithCreatorAndRejector: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllRejectedCustomersWithCreatorAndRejector: (state) => {
        state.getAllRejectedCustomersWithCreatorAndRejector.loading = false
        state.getAllRejectedCustomersWithCreatorAndRejector.error = false
        state.getAllRejectedCustomersWithCreatorAndRejector.data = []
        state.getAllRejectedCustomersWithCreatorAndRejector.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR.fulfilled, (state, action) => {
      state.getAllRejectedCustomersWithCreatorAndRejector = {
        ...state.getAllRejectedCustomersWithCreatorAndRejector,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR.pending, (state, action) => {
      state.getAllRejectedCustomersWithCreatorAndRejector = {
        ...state.getAllRejectedCustomersWithCreatorAndRejector,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR.rejected, (state, action) => {
      state.getAllRejectedCustomersWithCreatorAndRejector = {
        ...state.getAllRejectedCustomersWithCreatorAndRejector,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllRejectedCustomersWithCreatorAndRejectorAction = {
    GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR,
};

export { getAllRejectedCustomersWithCreatorAndRejectorAction };
export default getAllRejectedCustomersWithCreatorAndRejectorSlice.reducer;
export const {setInitialStateOfgetAllRejectedCustomersWithCreatorAndRejector} = getAllRejectedCustomersWithCreatorAndRejectorSlice.actions
